import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { TeamsModule } from 'app/main/pages/teams/teams.module';
import { MaxBrainSharedModule } from 'app/projects/shared/src/lib/shared.module';
import { MaxBrainAllModulesModule } from '../all-modules/all-modules.module';
import { UserDetailsCardModule } from '../shared/user-details-card/user-details-card.module';
import { TagMultiSelectModule } from '../tag/components/multi-select/multi-select.module';
import { TeamModule } from '../team/team.module';
import { RequestDateFilterModule } from '../training-approval-team-requests/components/filters/request-date-filter/request-date-filter.module';
import { ActiveUserListComponent } from './components/active-user-list/list.component';
import { ChangeUserEmailAddressDialogComponent } from './components/dialog/change-user-email-address/change-user-email-address-dialog.component';
import { FilterByDialogComponent } from './components/dialog/filter-by-dialog/filter-by-dialog.component';
import { FilterByModuleComponent } from './components/dialog/filter-by-module/filter-by-module-dialog.component';
import { AddressFilterComponent } from './components/filter/address-filter/address-filter.component';
import { AttributeWithOptionsFilterComponent } from './components/filter/attribute-with-options-filter/attribute-with-options-filter.component';
import { AudienceFilterComponent } from './components/filter/audience-filter/audience-filter.component';
import { DateFilterComponent } from './components/filter/date-filter/date-filter.component';
import { ExperienceFilterComponent } from './components/filter/experience-filter/experience-filter.component';
import { RangeFilterComponent } from './components/filter/range-filter/range-filter.component';
import { RoleFilterComponent } from './components/filter/role-filter/role-filter.component';
import { StatusFilterComponent } from './components/filter/status-filter/status-filter.component';
import { TeamFilterComponent } from './components/filter/team-filter/team-filter.component';
import { TextFilterComponent } from './components/filter/text-filter/text-filter.component';
import { SelectedFiltersChipRowComponent } from './components/selected-filters-chip/selected-filters-chip-row.component';
import { FilterAddressCityPipe } from './pipes/address-city-filter.pipe';
import { FilterAttributeOptionPipe } from './pipes/attribute-option-filter.pipe';
import { AllUsersApiService } from './services/all-users.api-service';
import { AllUsersService } from './services/all-users.service';

@NgModule({
    imports: [
        RouterModule,
        MaxBrainSharedModule,
        MatCheckboxModule,
        MatTableModule,
        MatMenuModule,
        MatSortModule,
        MatIconModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatPaginatorModule,
        MatChipsModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatSelectModule,
        MatListModule,
        MatInputModule,
        UserDetailsCardModule,
        TagMultiSelectModule,
        MatProgressSpinnerModule,
        MaxBrainAllModulesModule,
        DragDropModule,
        NgxSliderModule,
        MatTreeModule,
        TeamModule,
        TeamsModule,
        MatTooltipModule,
        MatRadioModule,
        MatDatepickerModule,
        RequestDateFilterModule,
    ],
    declarations: [
        ActiveUserListComponent,
        FilterByModuleComponent,
        ChangeUserEmailAddressDialogComponent,
        AudienceFilterComponent,
        TeamFilterComponent,
        ExperienceFilterComponent,
        FilterByDialogComponent,
        SelectedFiltersChipRowComponent,
        AttributeWithOptionsFilterComponent,
        AddressFilterComponent,
        DateFilterComponent,
        RangeFilterComponent,
        RoleFilterComponent,
        StatusFilterComponent,
        TextFilterComponent,
        FilterAttributeOptionPipe,
        FilterAddressCityPipe,
    ],
    exports: [
        ActiveUserListComponent,
        FilterByModuleComponent,
        ChangeUserEmailAddressDialogComponent,
        FilterByDialogComponent,
        SelectedFiltersChipRowComponent,
        AttributeWithOptionsFilterComponent,
        AddressFilterComponent,
        DateFilterComponent,
        RangeFilterComponent,
        RoleFilterComponent,
        TextFilterComponent,
        AudienceFilterComponent,
        TeamFilterComponent,
    ],
    providers: [provideMomentDateAdapter()],
})
export class MaxBrainAllUsersModule {
    static forRoot(): ModuleWithProviders<MaxBrainAllUsersModule> {
        return {
            ngModule: MaxBrainAllUsersModule,
            providers: [AllUsersApiService, AllUsersService],
        };
    }
}
